// Login screen translations for all 11 supported languages

export const loginTranslations = {
  pt: {
    title: "Entrar no MoneyLights",
    description: "Clareza financeira começa aqui.",
    trust_message: "Acesso seguro à sua informação financeira.",
    email: "Email",
    email_placeholder: "nome@empresa.com",
    password: "Palavra-passe",
    password_placeholder: "Introduza a sua palavra-passe",
    forgot_password: "Esqueceu a palavra-passe?",
    sign_in: "Entrar",
    signing_in: "A entrar...",
    or_continue_with: "Ou continuar com",
    continue_with_google: "Continuar com Google",
    continue_with_apple: "Continuar com Apple",
    continue_with_microsoft: "Continuar com Microsoft",
    no_account: "Não tem uma conta?",
    create_account: "Criar conta",
    error_required_fields: "Por favor preencha todos os campos",
    error_invalid_credentials: "Email ou palavra-passe incorretos",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® é uma marca registada.",
    need_help: "Precisa de ajuda?"
  },
  en: {
    title: "Sign in to MoneyLights",
    description: "Financial clarity starts here.",
    trust_message: "Secure access to your financial data.",
    email: "Email",
    email_placeholder: "name@company.com",
    password: "Password",
    password_placeholder: "Enter your password",
    forgot_password: "Forgot your password?",
    sign_in: "Sign in",
    signing_in: "Signing in...",
    or_continue_with: "Or continue with",
    continue_with_google: "Continue with Google",
    continue_with_apple: "Continue with Apple",
    continue_with_microsoft: "Continue with Microsoft",
    no_account: "Don't have an account?",
    create_account: "Create account",
    error_required_fields: "Please fill in all fields",
    error_invalid_credentials: "Incorrect email or password",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Need help?"
  },
  es: {
    title: "Accede a MoneyLights",
    description: "Claridad financiera empieza aquí.",
    trust_message: "Acceso seguro a tus datos financieros.",
    email: "Correo electrónico",
    email_placeholder: "nombre@empresa.com",
    password: "Contraseña",
    password_placeholder: "Introduce tu contraseña",
    forgot_password: "¿Olvidaste tu contraseña?",
    sign_in: "Iniciar sesión",
    signing_in: "Iniciando sesión...",
    or_continue_with: "O continuar con",
    continue_with_google: "Continuar con Google",
    continue_with_apple: "Continuar con Apple",
    continue_with_microsoft: "Continuar con Microsoft",
    no_account: "¿No tienes una cuenta?",
    create_account: "Crear cuenta",
    error_required_fields: "Por favor completa todos los campos",
    error_invalid_credentials: "Correo electrónico o contraseña incorrectos",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® es una marca registrada.",
    need_help: "¿Necesitas ayuda?"
  },
  fr: {
    title: "Connectez-vous à MoneyLights",
    description: "La clarté financière commence ici.",
    trust_message: "Accès sécurisé à vos données financières.",
    email: "Email",
    email_placeholder: "nom@entreprise.com",
    password: "Mot de passe",
    password_placeholder: "Entrez votre mot de passe",
    forgot_password: "Mot de passe oublié?",
    sign_in: "Se connecter",
    signing_in: "Connexion en cours...",
    or_continue_with: "Ou continuer avec",
    continue_with_google: "Continuer avec Google",
    continue_with_apple: "Continuer avec Apple",
    continue_with_microsoft: "Continuer avec Microsoft",
    no_account: "Vous n'avez pas de compte?",
    create_account: "Créer un compte",
    error_required_fields: "Veuillez remplir tous les champs",
    error_invalid_credentials: "Email ou mot de passe incorrect",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® est une marque déposée.",
    need_help: "Besoin d'aide?"
  },
  de: {
    title: "Bei MoneyLights anmelden",
    description: "Finanzielle Klarheit beginnt hier.",
    trust_message: "Sicherer Zugriff auf Ihre Finanzdaten.",
    email: "E-Mail",
    email_placeholder: "name@unternehmen.com",
    password: "Passwort",
    password_placeholder: "Geben Sie Ihr Passwort ein",
    forgot_password: "Passwort vergessen?",
    sign_in: "Anmelden",
    signing_in: "Anmelden...",
    or_continue_with: "Oder fortfahren mit",
    continue_with_google: "Mit Google fortfahren",
    continue_with_apple: "Mit Apple fortfahren",
    continue_with_microsoft: "Mit Microsoft fortfahren",
    no_account: "Noch kein Konto?",
    create_account: "Konto erstellen",
    error_required_fields: "Bitte füllen Sie alle Felder aus",
    error_invalid_credentials: "Falsche E-Mail oder Passwort",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® ist eine eingetragene Marke.",
    need_help: "Brauchen Sie Hilfe?"
  },
  it: {
    title: "Accedi a MoneyLights",
    description: "La chiarezza finanziaria inizia qui.",
    trust_message: "Accesso sicuro ai tuoi dati finanziari.",
    email: "Email",
    email_placeholder: "nome@azienda.com",
    password: "Password",
    password_placeholder: "Inserisci la tua password",
    forgot_password: "Password dimenticata?",
    sign_in: "Accedi",
    signing_in: "Accesso in corso...",
    or_continue_with: "O continua con",
    continue_with_google: "Continua con Google",
    continue_with_apple: "Continua con Apple",
    continue_with_microsoft: "Continua con Microsoft",
    no_account: "Non hai un account?",
    create_account: "Crea account",
    error_required_fields: "Si prega di compilare tutti i campi",
    error_invalid_credentials: "Email o password errati",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® è un marchio registrato.",
    need_help: "Hai bisogno di aiuto?"
  },
  nl: {
    title: "Log in bij MoneyLights",
    description: "Financiële helderheid begint hier.",
    trust_message: "Veilige toegang tot uw financiële gegevens.",
    email: "E-mail",
    email_placeholder: "naam@bedrijf.com",
    password: "Wachtwoord",
    password_placeholder: "Voer uw wachtwoord in",
    forgot_password: "Wachtwoord vergeten?",
    sign_in: "Inloggen",
    signing_in: "Inloggen...",
    or_continue_with: "Of ga verder met",
    continue_with_google: "Doorgaan met Google",
    continue_with_apple: "Doorgaan met Apple",
    continue_with_microsoft: "Doorgaan met Microsoft",
    no_account: "Geen account?",
    create_account: "Account aanmaken",
    error_required_fields: "Vul alle velden in",
    error_invalid_credentials: "Onjuiste e-mail of wachtwoord",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is een geregistreerd handelsmerk.",
    need_help: "Hulp nodig?"
  },
  da: {
    title: "Log ind på MoneyLights",
    description: "Finansiel klarhed starter her.",
    trust_message: "Sikker adgang til dine finansielle data.",
    email: "E-mail",
    email_placeholder: "navn@virksomhed.com",
    password: "Adgangskode",
    password_placeholder: "Indtast din adgangskode",
    forgot_password: "Glemt adgangskode?",
    sign_in: "Log ind",
    signing_in: "Logger ind...",
    or_continue_with: "Eller fortsæt med",
    continue_with_google: "Fortsæt med Google",
    continue_with_apple: "Fortsæt med Apple",
    continue_with_microsoft: "Fortsæt med Microsoft",
    no_account: "Har du ikke en konto?",
    create_account: "Opret konto",
    error_required_fields: "Udfyld venligst alle felter",
    error_invalid_credentials: "Forkert e-mail eller adgangskode",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® er et registreret varemærke.",
    need_help: "Brug for hjælp?"
  },
  sv: {
    title: "Logga in på MoneyLights",
    description: "Ekonomisk klarhet börjar här.",
    trust_message: "Säker åtkomst till dina finansiella data.",
    email: "E-post",
    email_placeholder: "namn@företag.com",
    password: "Lösenord",
    password_placeholder: "Ange ditt lösenord",
    forgot_password: "Glömt lösenord?",
    sign_in: "Logga in",
    signing_in: "Loggar in...",
    or_continue_with: "Eller fortsätt med",
    continue_with_google: "Fortsätt med Google",
    continue_with_apple: "Fortsätt med Apple",
    continue_with_microsoft: "Fortsätt med Microsoft",
    no_account: "Har du inget konto?",
    create_account: "Skapa konto",
    error_required_fields: "Vänligen fyll i alla fält",
    error_invalid_credentials: "Felaktig e-post eller lösenord",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® är ett registrerat varumärke.",
    need_help: "Behöver du hjälp?"
  },
  fi: {
    title: "Kirjaudu MoneyLightsiin",
    description: "Taloudellinen selkeys alkaa tästä.",
    trust_message: "Turvallinen pääsy taloustietoihisi.",
    email: "Sähköposti",
    email_placeholder: "nimi@yritys.com",
    password: "Salasana",
    password_placeholder: "Syötä salasanasi",
    forgot_password: "Unohditko salasanan?",
    sign_in: "Kirjaudu sisään",
    signing_in: "Kirjaudutaan...",
    or_continue_with: "Tai jatka",
    continue_with_google: "Jatka Googlella",
    continue_with_apple: "Jatka Applella",
    continue_with_microsoft: "Jatka Microsoftilla",
    no_account: "Eikö sinulla ole tiliä?",
    create_account: "Luo tili",
    error_required_fields: "Täytä kaikki kentät",
    error_invalid_credentials: "Väärä sähköposti tai salasana",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® on rekisteröity tavaramerkki.",
    need_help: "Tarvitsetko apua?"
  },
  et: {
    title: "Logi MoneyLightsi sisse",
    description: "Finantsiline selgus algab siit.",
    trust_message: "Turvaline ligipääs teie finantsandmetele.",
    email: "E-post",
    email_placeholder: "nimi@ettevõte.com",
    password: "Parool",
    password_placeholder: "Sisesta oma parool",
    forgot_password: "Unustasid parooli?",
    sign_in: "Logi sisse",
    signing_in: "Sisselogimine...",
    or_continue_with: "Või jätka",
    continue_with_google: "Jätka Google'iga",
    continue_with_apple: "Jätka Apple'iga",
    continue_with_microsoft: "Jätka Microsoftiga",
    no_account: "Pole kontot?",
    create_account: "Loo konto",
    error_required_fields: "Palun täida kõik väljad",
    error_invalid_credentials: "Vale e-post või parool",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® on registreeritud kaubamärk.",
    need_help: "Kas vajad abi?"
  }
};